import constants from '../constants';
import { getElementId } from '../../helpers';

export interface ThemedItemConfig {
	id: string;
	page: number;
}

interface ThemedItemsData {
	items: ThemedItemConfig[];
	isError: boolean;
}

const getConfig = (element: HTMLElement, page: number): ThemedItemConfig => ({
	page,
	id: getElementId(element),
});

export default (page: number, htmlDocument: Document, isAccountManagerOrAdmin: boolean): ThemedItemsData => {
	if (!isAccountManagerOrAdmin) {
		return {
			items: [],
			isError: false,
		};
	}

	const items: ThemedItemConfig[] = [];
	let isError: boolean = false;

	const elements = [
		...htmlDocument.querySelectorAll(`[class*=${constants.themedItemClassName}]`),
	] as HTMLElement[];

	try {
		elements
			.filter(element => {
				const isEnrichmentElement = !!element.querySelector(`[class*=${constants.enrichmentClassName}]`);
				const isButton = !!element.closest(`[class*=${constants.buttonClassName}]`);
				const isLink = !!element.closest('a');
				const isTextField = element.className.includes(constants.textFieldClassName);
				const isLocked = element.className.includes(constants.lockedClassName);
				const MSOParent = element.closest(`[class*=${constants.multiStateObjectClassName}]`);
				const isLockedMSOParent = !!MSOParent && MSOParent.className.includes(constants.lockedClassName);

				return !isEnrichmentElement &&
					!isButton &&
					!isLink &&
					!isTextField &&
					!isLocked &&
					!isLockedMSOParent;
			})
			.forEach(element => items.push(getConfig(element, page)));
	} catch (err) {
		isError = true;
	}

	return {
		items,
		isError,
	};
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/themedItems/getData.ts